var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13103_6715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8871 0.00498962C16.1103 0.00498962 0.888672 15.2267 0.888672 34.0034C0.888672 52.2368 15.2432 67.1178 33.2679 67.9622C33.8058 67.9876 34.3445 68.002 34.8875 68.002C43.5921 68.002 51.5305 64.7289 57.5456 59.3498C53.5603 61.9928 48.9009 63.5135 43.9215 63.5135C35.825 63.5135 28.5739 59.497 23.6971 53.163C19.9377 48.7253 17.5027 42.1655 17.3369 34.8037V33.2026C17.5026 25.841 19.9375 19.2799 23.6961 14.8433C28.5736 8.50932 35.8245 4.49274 43.9205 4.49274C48.9012 4.49274 53.5614 6.01347 57.547 8.65817C51.5615 3.30365 43.671 0.0373077 35.0149 0.0051651C34.9718 0.0051651 34.9295 0.003479 34.8864 0.003479L34.8871 0.00498962Z",
    fill: "url(#paint0_linear_13103_6715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6963 14.8454C26.8163 11.1621 30.8456 8.94104 35.2478 8.94104C45.1458 8.94104 53.1681 20.1627 53.1681 34.0051C53.1681 47.8474 45.1452 59.0691 35.2478 59.0691C30.8456 59.0691 26.8163 56.849 23.6971 53.1656C28.5738 59.4995 35.8243 63.5161 43.9215 63.5161C48.9014 63.5161 53.5607 61.9954 57.5456 59.3524C64.5046 53.1267 68.8865 44.0779 68.8865 34.0053C68.8865 23.9339 64.5054 14.8855 57.5481 8.66061C53.562 6.01592 48.9018 4.49519 43.9217 4.49519C35.8252 4.49519 28.5731 8.51141 23.6963 14.8454Z",
    fill: "url(#paint1_linear_13103_6715)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13103_6715",
    x1: 29.2187,
    y1: 1.11325,
    x2: 29.2187,
    y2: 67.0135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13103_6715",
    x1: 46.2907,
    y1: 4.99822,
    x2: 46.2907,
    y2: 63.2834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13103_6715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.888672)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/opera.9c32121a262ee1fbbe55a8cb30b1e8e3.svg";